<template>
  <main class="main" role="main">
    <div class="fab_top">
      <button v-on:click="fnTop" id="MOVE_TOP_BTN">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48px"
          height="48px"
          viewBox="0 0 48 48"
        >
          <g>
            <polygon
              points="14.1,27.3 15.5,28.7 24,20.3 32.5,28.7 33.9,27.3 24,17.3"
            />
          </g>
        </svg>
      </button>
    </div>
    <div class="page home">
      <!--'홈: home'-->
      <div class="inner">
        <!--섹션 1-->
        <main-banner />
        <!--//섹션 1-->
        <!--섹션 2-->
        <main-contents />
        <!--//섹션 2-->
        <!--섹션 3-->
        <main-kfood />
        <!--//섹션 3-->
        <!--섹션 4-->
        <main-notice />
        <main-logos />
      </div>
    </div>
  </main>
</template>

<script>
import MainBanner from '@/components/pages/main/banner/index'
import MainContents from '@/components/pages/main/contents/index'
import MainKfood from '@/components/pages/main/kfood/index'
import MainNotice from '@/components/pages/main/notice/index'
import MainLogos from '@/components/pages/main/logos/index'
export default {
  name: 'main-index',
  components: { MainBanner, MainContents, MainKfood, MainNotice, MainLogos },
  data: function() {
    return {
      items: []
    }
  },
  created() {
    this.fetchPopupData()
  },
  mounted() {
    // 창 크기 변경 시 이벤트 리스너 등록
    //window.addEventListener('resize', this.setElementClass);
  },
  methods: {
    fetchPopupData: async function() {
      const res = await this.$MainSvc.getListBoxPopup()
      if (res.code === 1) {
        this.items = res.entity.list
      }
      this.fnModalAlert()
    },
    fnModalAlert: function() {
      if (this.$Util.isEmpty(this.items[0].imagePath)) return
      // if (!this.$Util.isEmpty(this.$cookies.get('isNone'))) return
      // 모든 팝업이 하루동안 보이지 않기인 경우, 팝업 미표출 (서남아이에스 임현아, 2024-07-02)
      var popupCnt = 0;

      for(var i = 0; i < this.items.length; i++){
        if(!this.$Util.isEmpty(this.$cookies.get('isNonehm'+i))){
          popupCnt += 1;
        }
      }

      if(this.items.length === popupCnt) return

      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_MAIN_POPUP,
        data: { items: this.items },
        callBack: () => {
          console.log('hahaha')
        }
      })
    },
    fnTop: function() {
      window.scrollTo(0, 0)
    },
    setElementClass: function() {
      // 창 크기 줄여도 사이드 배너 잘 보이도록
      if(window.innerWidth < 1400){
        document.getElementById('sidebanner').style.left = '1300px';
      }else{
        document.getElementById('sidebanner').style.left = 'calc(50% + 1200px / 2)';
      }
      console.log(window.innerWidth)
    }
  }
}
</script>

<style scoped></style>
